import { gql } from '@apollo/client';

export default gql`
  mutation updateSalesforceStaffVouchersForBooking($bookingReference: String!, $vouchersUsed: Int!) {
    updateSalesforceStaffVouchersForBooking(bookingReference: $bookingReference, vouchersUsed: $vouchersUsed)
  }
`;
